import { Component, Fragment, ReactNode } from 'react';

// @ts-ignore TODO: fix noImplicitAny error here
import Helmet from 'react-helmet';
import { FormattedMessage } from 'react-intl';

import FeatureGates from '@atlaskit/feature-gate-js-client';
import { Grid, GridColumn } from '@atlaskit/page';
import { StatsigFeatureKeys } from '@atlassian/bitbucket-features';

import Sidebar from 'src/app/sidebar';
import { Repository } from 'src/components/types';
import ConnectSourceViewWebpanels from 'src/connect/web-panels/containers/source-web-panels';
import { LazyForgeRepoCodeOverviewPanel } from 'src/forge/repo-code-overview-panel/lazy-repo-code-overview-panel';
import { Link, withRouter } from 'src/router';
import { RouteComponentProps } from 'src/router/types';

import LargeRepositoryWarningMessage from '../../../components/large-repository-warning-message';
import { RepositoryPrivilege } from '../../../types';
import repoUrls from '../../../urls';
import Header from '../containers/header';
import SourceSidebar from '../containers/sidebar';
import { TreeEntryType } from '../types';

import messages from './index.i18n';
import * as styles from './index.style';

type SourcePageProps = RouteComponentProps & {
  children: ReactNode;
  header?: ReactNode;
  path: string | null | undefined;
  pathType?: TreeEntryType;
  repository: Repository | null | undefined;
  repositoryAccessLevel?: RepositoryPrivilege;
  userUuid?: string | undefined;
  isUpToSmallBreakpointActive?: boolean;
};

class SourcePage extends Component<SourcePageProps> {
  renderDescription(): ReactNode {
    const { repository, repositoryAccessLevel } = this.props;

    if (!repository) {
      return null;
    }

    if (repository.description) {
      return (
        <styles.RepositoryDescription>
          {repository.description}
        </styles.RepositoryDescription>
      );
    }

    if (!repositoryAccessLevel || repositoryAccessLevel !== 'admin') {
      return null;
    }

    const [owner, slug] = repository.full_name.split('/');
    const enableClientSideLinking = FeatureGates.checkGate(
      StatsigFeatureKeys.enableClientSideLinking
    );

    return (
      <styles.RepositoryDescription>
        <FormattedMessage
          {...messages.repositoryDescriptionPlaceholder}
          values={{
            addRepositoryDescriptionLink: enableClientSideLinking ? (
              <Link href={repoUrls.ui.admin(owner, slug)}>
                <FormattedMessage {...messages.addRepositoryDescriptionLink} />
              </Link>
            ) : (
              <a href={repoUrls.ui.admin(owner, slug)}>
                <FormattedMessage {...messages.addRepositoryDescriptionLink} />
              </a>
            ),
          }}
        />
      </styles.RepositoryDescription>
    );
  }

  renderTitle(): ReactNode {
    const { path } = this.props;
    if (path && path.length) {
      // Set page title to `owner / name / optional / path`
      const title = `${path}`.replace(/\//g, ' / ');

      return <Helmet defer={false} title={title} />;
    }

    return null;
  }

  render(): ReactNode {
    const {
      header,
      path,
      pathType,
      repository,
      repositoryAccessLevel,
      userUuid,
      isUpToSmallBreakpointActive,
    } = this.props;
    const isLoggedIn = !!userUuid;

    return (
      <styles.Page>
        {this.renderTitle()}
        <Header path={path} pathType={pathType} />
        <Grid
          layout="fluid"
          spacing={isUpToSmallBreakpointActive ? 'cosy' : 'comfortable'}
        >
          <GridColumn>
            <LazyForgeRepoCodeOverviewPanel />
            {!path && <ConnectSourceViewWebpanels />}
            {repository && repository.size && (
              <LargeRepositoryWarningMessage
                size={repository.size}
                repositoryAccessLevel={repositoryAccessLevel}
                userUuid={userUuid}
                repositoryUuid={repository.uuid}
              />
            )}
            {this.renderDescription()}
            {header && (
              <Fragment>
                <styles.SelectorsHeader>{header}</styles.SelectorsHeader>
              </Fragment>
            )}
            {this.props.children}
          </GridColumn>
        </Grid>

        <Sidebar>
          {/* OOF. First, terrible ts-ignore style.
              Second, this component is a container but TS doesn't seem to
              realize the props being injected from mapDispatchToProps
            // @ts-ignore */}
          <SourceSidebar path={this.props.path} isLoggedIn={isLoggedIn} />
        </Sidebar>
      </styles.Page>
    );
  }
}

export default withRouter(SourcePage);
